import React from 'react'
import { CommonLoader } from '@/components/common'
import { SubSection, StyledDemoGrid, DemoComponent } from '../styled.jsx'

export const LoaderSection = () => {
  return (
    <>
      {/* Sizes */}
      <SubSection
        title='Loader Sizes'
        description='Different size options for the circular loader'
      >
        <StyledDemoGrid>
          <DemoComponent
            label='Small (20)'
            component={<CommonLoader size={20} />}
          />
          <DemoComponent
            label='Medium (40)'
            component={<CommonLoader size={40} />}
          />
          <DemoComponent
            label='Large (60)'
            component={<CommonLoader size={60} />}
          />
        </StyledDemoGrid>
      </SubSection>

      {/* Colors */}
      <SubSection
        title='Loader Colors'
        description='Use theme colors for different contexts'
      >
        <StyledDemoGrid>
          <DemoComponent
            label='Primary'
            component={<CommonLoader color='primary' />}
          />
          <DemoComponent
            label='Secondary'
            component={<CommonLoader color='secondary' />}
          />
          <DemoComponent
            label='Success'
            component={<CommonLoader color='success' />}
          />
          <DemoComponent
            label='Error'
            component={<CommonLoader color='error' />}
          />
          <DemoComponent
            label='Info'
            component={<CommonLoader color='info' />}
          />
          <DemoComponent
            label='Warning'
            component={<CommonLoader color='warning' />}
          />
        </StyledDemoGrid>
      </SubSection>

      {/* Thickness */}
      <SubSection
        title='Loader Thickness'
        description='Adjust the stroke thickness for visual weight'
      >
        <StyledDemoGrid>
          <DemoComponent
            label='Thin (2)'
            component={<CommonLoader size={40} thickness={2} />}
          />
          <DemoComponent
            label='Default (3.6)'
            component={<CommonLoader size={40} thickness={3.6} />}
          />
          <DemoComponent
            label='Thick (6)'
            component={<CommonLoader size={40} thickness={6} />}
          />
        </StyledDemoGrid>
      </SubSection>
    </>
  )
}
